// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interaction-controls-container {
  display: flex;
  flex-direction: row;
  gap: var(--dialog-element-gap);

  > button:not(.interaction-controls-button-transparent) {
    background: var(--dialog-background-color);
  }
}

.interaction-controls-button-sharing {
  background-color: var(--warn-color) !important;
}

.interaction-controls-sharing-option-mine {
  font-weight: bold !important;
  background-color: var(--light-blue-background-color);
}

.interaction-controls-button-speaking:not(
    .interaction-controls-button-transparent
  ) {
  animation: pulse 0.5s ease-in-out infinite alternate;
}

@keyframes pulse {
  0% {
    background: radial-gradient(
      circle,
      var(--warn-color) 20%,
      var(--dialog-background-color) 100%
    );
  }
  12.5% {
    background: radial-gradient(
      circle,
      var(--warn-color) 17.5%,
      var(--dialog-background-color) 95%
    );
  }
  25% {
    background: radial-gradient(
      circle,
      var(--warn-color) 15%,
      var(--dialog-background-color) 90%
    );
  }
  37.5% {
    background: radial-gradient(
      circle,
      var(--warn-color) 12.5%,
      var(--dialog-background-color) 85%
    );
  }
  50% {
    background: radial-gradient(
      circle,
      var(--warn-color) 10%,
      var(--dialog-background-color) 80%
    );
  }
  62.5% {
    background: radial-gradient(
      circle,
      var(--warn-color) 7.5%,
      var(--dialog-background-color) 75%
    );
  }
  75% {
    background: radial-gradient(
      circle,
      var(--warn-color) 5%,
      var(--dialog-background-color) 70%
    );
  }
  87.5% {
    background: radial-gradient(
      circle,
      var(--warn-color) 2.5%,
      var(--dialog-background-color) 65%
    );
  }
  100% {
    background: radial-gradient(
      circle,
      var(--warn-color) 0%,
      var(--dialog-background-color) 60%
    );
  }
}

.interaction-controls-button-speaking.interaction-controls-button-transparent {
  animation: pulse_transparent 0.5s ease-in-out infinite alternate;
}

@keyframes pulse_transparent {
  0% {
    background: radial-gradient(
      circle,
      var(--warn-color) 20%,
      transparent 100%
    );
  }
  12.5% {
    background: radial-gradient(
      circle,
      var(--warn-color) 17.5%,
      transparent 95%
    );
  }
  25% {
    background: radial-gradient(circle, var(--warn-color) 15%, transparent 90%);
  }
  37.5% {
    background: radial-gradient(
      circle,
      var(--warn-color) 12.5%,
      transparent 85%
    );
  }
  50% {
    background: radial-gradient(circle, var(--warn-color) 10%, transparent 80%);
  }
  62.5% {
    background: radial-gradient(
      circle,
      var(--warn-color) 7.5%,
      transparent 75%
    );
  }
  75% {
    background: radial-gradient(circle, var(--warn-color) 5%, transparent 70%);
  }
  87.5% {
    background: radial-gradient(
      circle,
      var(--warn-color) 2.5%,
      transparent 65%
    );
  }
  100% {
    background: radial-gradient(circle, var(--warn-color) 0%, transparent 60%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/interaction-controls/InteractionControls.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,oDAAoD;AACtD;;AAEA;;;EAGE,oDAAoD;AACtD;;AAEA;EACE;IACE;;;;KAIC;EACH;EACA;IACE;;;;KAIC;EACH;EACA;IACE;;;;KAIC;EACH;EACA;IACE;;;;KAIC;EACH;EACA;IACE;;;;KAIC;EACH;EACA;IACE;;;;KAIC;EACH;EACA;IACE;;;;KAIC;EACH;EACA;IACE;;;;KAIC;EACH;EACA;IACE;;;;KAIC;EACH;AACF;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE;IACE;;;;KAIC;EACH;EACA;IACE;;;;KAIC;EACH;EACA;IACE,2EAA2E;EAC7E;EACA;IACE;;;;KAIC;EACH;EACA;IACE,2EAA2E;EAC7E;EACA;IACE;;;;KAIC;EACH;EACA;IACE,0EAA0E;EAC5E;EACA;IACE;;;;KAIC;EACH;EACA;IACE,0EAA0E;EAC5E;AACF","sourcesContent":[".interaction-controls-container {\n  display: flex;\n  flex-direction: row;\n  gap: var(--dialog-element-gap);\n\n  > button:not(.interaction-controls-button-transparent) {\n    background: var(--dialog-background-color);\n  }\n}\n\n.interaction-controls-button-sharing {\n  background-color: var(--warn-color) !important;\n}\n\n.interaction-controls-sharing-option-mine {\n  font-weight: bold !important;\n  background-color: var(--light-blue-background-color);\n}\n\n.interaction-controls-button-speaking:not(\n    .interaction-controls-button-transparent\n  ) {\n  animation: pulse 0.5s ease-in-out infinite alternate;\n}\n\n@keyframes pulse {\n  0% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 20%,\n      var(--dialog-background-color) 100%\n    );\n  }\n  12.5% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 17.5%,\n      var(--dialog-background-color) 95%\n    );\n  }\n  25% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 15%,\n      var(--dialog-background-color) 90%\n    );\n  }\n  37.5% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 12.5%,\n      var(--dialog-background-color) 85%\n    );\n  }\n  50% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 10%,\n      var(--dialog-background-color) 80%\n    );\n  }\n  62.5% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 7.5%,\n      var(--dialog-background-color) 75%\n    );\n  }\n  75% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 5%,\n      var(--dialog-background-color) 70%\n    );\n  }\n  87.5% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 2.5%,\n      var(--dialog-background-color) 65%\n    );\n  }\n  100% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 0%,\n      var(--dialog-background-color) 60%\n    );\n  }\n}\n\n.interaction-controls-button-speaking.interaction-controls-button-transparent {\n  animation: pulse_transparent 0.5s ease-in-out infinite alternate;\n}\n\n@keyframes pulse_transparent {\n  0% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 20%,\n      transparent 100%\n    );\n  }\n  12.5% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 17.5%,\n      transparent 95%\n    );\n  }\n  25% {\n    background: radial-gradient(circle, var(--warn-color) 15%, transparent 90%);\n  }\n  37.5% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 12.5%,\n      transparent 85%\n    );\n  }\n  50% {\n    background: radial-gradient(circle, var(--warn-color) 10%, transparent 80%);\n  }\n  62.5% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 7.5%,\n      transparent 75%\n    );\n  }\n  75% {\n    background: radial-gradient(circle, var(--warn-color) 5%, transparent 70%);\n  }\n  87.5% {\n    background: radial-gradient(\n      circle,\n      var(--warn-color) 2.5%,\n      transparent 65%\n    );\n  }\n  100% {\n    background: radial-gradient(circle, var(--warn-color) 0%, transparent 60%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
